export default "__VITE_ASSET__n$i_V4nL__"